import * as React from "react"
import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"
import { batch } from "@preact/signals-react"
import { Grid } from "@mui/material"

import PageWrapper from "Pages/@PageWrapper"
import { MARKETPLACES_ROUTES } from "@constants"
import {useUserApp} from "@hooks"
import { commonFiltersValue, isLoadingCommonFilters, isSystemBusy } from "@signals"
import { TourProvider, TourTarget } from "@tour"
import { isEmpty, resetMarketplacesSellerDeepDive } from "./@signals"
import MarketplacesSellerDeepDiveFilters from "./Filters"
import SellerDeepDiveTable from "./Table"
import SellerDeepDiveReportFormDrawer from "./ReportForm";
import SellerDeepDiveShareMblChart from "./ShareMblChart"
import SellerDeepShareMblEvolutionChart from "./ShareMblEvolutionChart"

const HEIGHT = 200

export default function MarketplacesSellerDeepDivePage() {

	const { userUseRRSP } = useUserApp()
	
	useEffect(() => {
        return () => resetMarketplacesSellerDeepDive()
    }, [])

	return <PageWrapper
		head={`DIP Insight | ${MARKETPLACES_ROUTES.TITLE}`}
		title={MARKETPLACES_ROUTES.TITLE}
		subtitle={MARKETPLACES_ROUTES.SELLER_DEEP_DIVE_SUBTITLE}
		isEmpty={isEmpty.value}
		filters={<MarketplacesSellerDeepDiveFilters />}
		hasErrors={isSystemBusy.value}
		tourPageKey="sellerDeepDive"
	>
		<Grid container spacing={4} sx={{ mt: 1 }}>
			{!!userUseRRSP && <Grid item xs={12} data-tour="seller-deep-dive-chart">
				<SellerDeepDiveShareMblChart
					sx={{ minHeight: HEIGHT }}
					title={'Share Of Same / Low / Above RRSP'}
				/>
			</Grid>}

			<Grid item xs={12} sx={{ position: "relative" }}>
				<TourTarget name="seller-deep-dive-table" height={350} />
				<SellerDeepDiveTable />
			</Grid>

			<Grid item xs={12}>
				<SellerDeepDiveReportFormDrawer />
			</Grid>

			<Grid item xs={12}>
				<SellerDeepShareMblEvolutionChart />
			</Grid>
		</Grid>
	</PageWrapper>
}